/**
 * SignaturePadField.tsx
 *
 * Signature pad field component
 * Note: This is a placeholder that will be fully implemented in Phase 2
 */

import React from 'react';
import { BaseFieldProps } from './shared/types';
import { FieldWrapper } from './shared';

export const SignaturePadField: React.FC<BaseFieldProps> = React.memo(({
  fieldConfig,
  mode,
  value,
  onChange,
  errors = [],
  disabled = false,
  hasError = false,
}) => {
  // TODO: Implement full signature pad functionality
  // For now, this is a placeholder
  const isPreviewMode = mode === 'preview';

  return (
    <FieldWrapper
      field={fieldConfig}
      errors={errors}
      hasError={hasError}
      isPreview={isPreviewMode}
    >
      <div className="w-full h-48 border-2 border-blue-200 rounded-md bg-white relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="text-sm text-muted-foreground">
            Signature Pad - To be implemented
          </p>
        </div>
      </div>
    </FieldWrapper>
  );
});

SignaturePadField.displayName = 'SignaturePadField';
